<template>
  <div>
    <div class="columns">
      <div class="column">
        <h2 class="title is-3">Аккаунты leadgid</h2>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-button
          class="is-pulled-right"
          type="is-primary"
          icon-right="plus"
          @click="createAccountLeadgid">
          Добавить аккаунт</b-button>
      </div>
    </div>

    <!-- ТАБЛИЦА -->
    <b-table
      :data="leadgid_accounts"
      class="users-table"
    >
      <b-table-column v-slot="props">
        <span>{{ props.row.is_favorite ? '⭐' : '' }}</span>
      </b-table-column>

<!--      <b-table-column label="ID" v-slot="props">-->
<!--        <span>{{ props.row.id }}</span>-->
<!--      </b-table-column>-->

      <b-table-column label="Leadgid ID" v-slot="props">
        <span>{{ props.row.leadgid_id }}</span>
      </b-table-column>

      <b-table-column label="Имя" v-slot="props">
        <span>{{ props.row.name }}</span>
      </b-table-column>

      <b-table-column label="Действия" v-slot="props">

        <b-tooltip label="Редактировать">
          <b-button class="edit_icon" @click="updateLeadgidAccount(props.row.id)">
            <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
              <path d="M13.5 6.5l4 4"></path>
            </svg>
          </b-button>
        </b-tooltip>

        <b-tooltip label="Удалить">
          <b-button
            class="delete_icon"
            @click="deleteLeadgidAccount(props.row.id)">
            <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 7l16 0"></path>
              <path d="M10 11l0 6"></path>
              <path d="M14 11l0 6"></path>
              <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
              <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
            </svg>
          </b-button>
        </b-tooltip>

      </b-table-column>

    </b-table>

    <LeadgidDetailsModal/>
    <ConfirmDeletionLeadgidModal/>

    <OverlayLoader :show="isLoading"/>

  </div>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";
import LeadgidDetailsModal from "@/app/client/offers_rate/leadgid/shared/modals/leadgidDetailsModal.vue";
import ConfirmDeletionLeadgidModal
  from "@/app/client/offers_rate/leadgid/shared/modals/confirmDeletionLeadgidModal.vue";

export default {
  name: "LeadgidAccounts",
  components: {
    OverlayLoader,
    LeadgidDetailsModal,
    ConfirmDeletionLeadgidModal
  },
  data() {
    return {
    };
  },
  created() {
    this.getLeadgidAccounts();
  },
  watch: {
    detailOpened(newVal) {
      if (!newVal) {
        this.getLeadgidAccounts();
      }
    },
    isOpenConfirmDeletionModalLeadgidAccount(newVal) {
      if (!newVal) {
        this.getLeadgidAccounts();
      }
    }
  },
  computed: {
    leadgid_accounts() {
      return this.$store.getters.GET_LEADGID_ACCOUNTS;
    },
    isLoading: {
      get() {
        return this.$store.getters.IS_LEADGID_ACCOUNTS_LOADING;
      },
      set(value) {
        this.$store.commit("SET_LEADGID_ACCOUNTS_LOADING", value);
      },
    },
    detailOpened: {
      get() {
        return this.$store.getters.GET_LEADGID_ACCOUNT_DETAILS_MODAL_OPENED;
      },
      set(value) {
        this.$store.commit("SET_LEADGID_ACCOUNT_DETAILS_MODAL_OPENED", value);
      },
    },
    isOpenConfirmDeletionModalLeadgidAccount: {
      get() {
        return this.$store.getters.GET_LEADGID_ACCOUNT_DETAILS_MODAL_CONFIRM_DELETION;
      },
      set(value) {
        this.$store.commit("SET_CONFIRM_DELETION_LEADGID_ACCOUNT_MODAL", value);
      }
    },
  },
  methods: {
    createAccountLeadgid() {
      this.$store.commit("SET_CURRENT_LEADGID_ACCOUNT", {'is_favorite': false});
      this.detailOpened = true;
    },
    updateLeadgidAccount(id) {
      this.$store.dispatch("GET_LEADGID_ACCOUNT_BY_ID", id).then(() => {
        this.detailOpened = true;
      }).catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    deleteLeadgidAccount(id) {
      this.$store.dispatch("GET_LEADGID_ACCOUNT_BY_ID", id).then(() => {
        this.isOpenConfirmDeletionModalLeadgidAccount = true;
      }).catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    getLeadgidAccounts() {
      this.$store.dispatch("GET_LEADGID_ACCOUNTS").catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
  },
};
</script>
